import { useSearchParams } from 'react-router-dom';
import { GenerateDesignModal } from './GenerateDesignModal';

/**
 * Site-wide host for the "Generate design" modal, driven by `?generate=design` so the Topbar's New
 * Content dropdown can open it from any screen without navigating away.
 *
 * Mirrors GenerateMediaModalHost exactly, including the same `generate` param — the two are mutually
 * exclusive by construction, since one param cannot hold both values.
 */
export function GenerateDesignModalHost() {
  const [params, setParams] = useSearchParams();
  const open = params.get('generate') === 'design';

  const close = () => {
    const next = new URLSearchParams(params);
    next.delete('generate');
    setParams(next, { replace: true });
  };

  if (!open) return null;
  return <GenerateDesignModal open onClose={close} />;
}
